import cn from "classnames";
import React from "react";

interface LoadingProps {
  size?: "small" | "medium" | "large";
  className?: string;
}

const sizeClasses = {
  small: "h-5 w-5",
  medium: "h-10 w-10",
  large: "h-16 w-16",
};

export const Loading: React.FC<LoadingProps> = ({
  size = "medium",
  className,
}) => {
  return (
    <div
      className={cn("flex items-center justify-center min-h-full", className)}
    >
      <svg
        className={cn("animate-spin text-primary-400", sizeClasses[size])}
        fill="none"
        viewBox="0 0 24 24"
        stroke="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
    </div>
  );
};
